<template>
	<div>
		<Top></Top>
		<div class="wd-container">
			<div class="nav">
				<router-link tag="span" :to="{ path: '/' }" class="wd-cursor">全部 ></router-link>
				<router-link
					v-if="goodsinfo.classname != ''"
					tag="span"
					:to="{ path: '/goodslist', query: { contype: 3, classid: goodsinfo.classid, showname: goodsinfo.classname } }"
					class="wd-cursor"
				>
					{{ goodsinfo.classname }} >
				</router-link>
				<router-link
					v-if="goodsinfo.brandname != ''"
					tag="span"
					:to="{ path: '/goodslist', query: { contype: 7, con: goodsinfo.brandid, showname: goodsinfo.brandname } }"
					class="wd-cursor"
				>
					{{ goodsinfo.brandname }} >
				</router-link>
				<span v-if="goodsinfo.shortname != ''">{{ goodsinfo.shortname }}</span>
			</div>
			<div class="wd-flex wd-row-between goodsinfo wd-col-top" >
				<div class="goodsimg">
					<div class="img_lg">
						<!-- <el-image :src="$wdpicurl(bigpic)" class="img"></el-image> -->
						<pic-zoom :url="$wdpicurl(bigpic)" :scale="3" :scroll="true"></pic-zoom>
					</div>
					<div class="wd-flex wd-row-left wd-m-t-10">
						<div v-for="(item, index) in goodspiclist" :key="index" class="img_xs" :class="item.select ? 'select' : ''" @click="selectgoodspic(index)">
							<el-image class="img" :src="$wdpicurl(item.picurl)"></el-image>
							<i></i>
						</div>
					</div>
				</div>
				<div class="info wd-row-grow wd-m-l-20">
					<div class="countdown" v-if="flag!=1 && goodsinfo!='' && goodsinfo.skdetailid!='0'">
						<div class="title">
							<span class="" v-if="goodsinfo.seckilltype==1">商品拼团</span>
							<span class="" v-else-if="goodsinfo.seckilltype==2">商品砍价</span>
							<span class="" v-else-if="goodsinfo.seckilltype==3">商品预售</span>
							<span class="" v-else>每日必抢</span>
						</div>
						<div class="wd-flex wd-row-right wd-m-r-10">
							<div class="value">结束倒计时</div>
							<div class="timer">
								<div class="a">{{sechour}}</div>
								<div class="a">{{secminute}}</div>
								<div class="a b">{{secsecond}}</div>
							</div>
						</div>
					</div>
					<div class="name wd-m-b-10">{{ goodsinfo.goodsname }}</div>
						
					<div class="wd-flex wd-row-between wd-col-top">
						<div>
							<div class="wd-flex wd-row-between other" v-if="flag==1">
								<div class="title">积分兑换：</div>
								<div class="wd-row-grow wd-theme ">
									<span class="">
										积分
									</span>
									<span class="wd-font-22">
										{{ goodsinfo.integralexchange|amountFormatter }}
									</span>
									<span class="wd-m-l-5" v-if="goodsinfo.integralmoney>0">
										+&nbsp;&nbsp;¥
									</span>
									<span class=" wd-font-22" v-if="goodsinfo.integralmoney>0">
										{{ goodsinfo.integralmoney|amountFormatter }}
									</span>
								</div>
							</div>
							<div v-else>
								<div  v-if="goodsinfo!='' && goodsinfo.skdetailid!='0'">
									<div class="wd-flex wd-row-between other">
										<div class="title wd-theme " v-if="goodsinfo.seckilltype==1">拼团价格：</div>
										<div class="title wd-theme " v-else-if="goodsinfo.seckilltype==2">砍价价格：</div>
										<div class="title wd-theme " v-else-if="goodsinfo.seckilltype==3">预售价格：</div>
										<div class="title wd-theme " v-else>抢购价格：</div>
										<!-- <div class="wd-row-grow wd-theme wd-font-22" v-if="goodsinfo.seckilltype==''||goodsinfo.seckilltype=='0'" >¥{{ goodsinfo.price1|amountFormatter }}</div> -->
										<div class="wd-row-grow wd-theme wd-font-22" v-if="goodsinfo.seckilltype==1">¥{{ selectprice|amountFormatter }}</div>
										<div class="wd-row-grow wd-theme wd-font-22" v-else>¥{{ goodsinfo.appprice|amountFormatter }}</div>
									</div>
								</div>
								<div class="wd-flex wd-row-between other" v-else>
									<div class="title">商城价格：</div>
									<div class="wd-row-grow wd-theme wd-font-22">¥{{ goodsinfo.price1|amountFormatter }}</div>
								</div>
							</div>
							<div class="wd-flex wd-row-between other">
								<div class="title">市场价格：</div>
								<div class="wd-row-grow wd-font-delete wd-theme-666">¥{{ goodsinfo.retailprice|amountFormatter }}</div>
							</div>
						</div>
						<div class="wd-m-r-20 wd-flex wd-row-around wd-text-center wd-font-12 wd-theme-666 wd-row-noshrink">
							<div class="">
								<p>累计评价</p>
								<p class="wd-theme wd-font-bold">{{ goodsinfo.commentnum }}</p>
							</div>
							<div class="sx"></div>
							<div class="wd-m-l-10">
								<p>累计销量</p>
								<p class="wd-theme wd-font-bold">{{ goodsinfo.salenum }}</p>
							</div>
						</div>
					</div>
					<div class="wd-flex wd-row-between other" v-if="goodsinfo.seckilltype==3">
						<el-steps :active="3" style="width:60%" align-center>
							<el-step v-for="(item,index) in yushouList" :key="index">
								<span slot="title" class=" wd-font-12">{{item.name}}</span>
							</el-step>
						</el-steps>
					</div>
					<div class="wd-flex wd-row-between other" v-if="yingxiaolist!=''">
						<div class="title">
							优惠活动：
						</div>
						<div class="wd-row-grow">
							<el-collapse>
								<el-collapse-item :title="yxitem.yxtype" name="1" v-for="(yxitem,yxindex) in yingxiaolist" :key="yxindex">
									<div>{{yxitem.name}}:{{yxitem.memo}}</div>
								</el-collapse-item>
							</el-collapse>
						</div>
					</div>
					<div class="wd-flex wd-row-between other">
						<div class="title">配送地址：</div>
						<div class="wd-row-grow selectaddrcss">
							<el-cascader
								ref="addr"
								class=""
								v-model="logininfo.addrinfo"
								:options="options"
								style="width: 100%;"
								placeholder="请选择所在地区"
								@change="handleChange"
							/>
						</div>
					</div>
					<div class="wd-flex wd-row-between other">
						<div class="title">服务商家：</div>
						<div class="wd-row-grow wd-theme-666">
							由
							<span class="wd-m-l-10 wd-m-r-10 wd-theme">{{ goodsinfo.branchname }}</span>
							发货并提供售后服务
						</div>
					</div>
					<div class="wd-flex wd-row-between other" v-if="goodsinfo.linklist!=''">
						<div class="title">选择规格：</div>
						<div class="wd-row-grow wd-theme-666 wd-flex wd-row-left wd-flex-wrap">
							<!-- @click="selectspecopt(index)" -->
							<div
								class="spec wd-flex wd-row-between"
								:class="item.goodsid == goodsid ? 'select' : ''"
								v-for="(item, index) in goodsinfo.linklist"
								:key="index"
								@click="setnewgoods(item.goodsid, item.goodsname)"
							>
								<el-image :src="$wdpicurl(item.pic1)" class="wd-img-40"></el-image>
								{{ item.shortname }}
							</div>
						</div>
					</div>
					<div class="wd-flex wd-row-between other" v-if="goodsinfo.needcolorsize">
						<div class="title">选择颜色：</div>
						<div class="wd-row-grow wd-theme-666 wd-flex wd-row-left wd-flex-wrap">
							<div class="spec wd-flex wd-row-between" :class="colorindex == selectcolorindex ? 'select' : ''" 
							v-for="(coloritem,colorindex) in goodsinfo.colorsize.color" :key="colorindex"
							@click="selectcolorindex=colorindex"
							>
							{{coloritem.name}}
							</div>
						</div>
					</div>
					<div class="wd-flex wd-row-between other" v-if="goodsinfo.needcolorsize">
						<div class="title">选择尺码：</div>
						<div class="wd-row-grow wd-theme-666 wd-flex wd-row-left wd-flex-wrap">
							<div class="spec wd-flex wd-row-between" :class="sizeindex == selectsizeindex ? 'select' : ''" 
							v-for="(sizeitem,sizeindex) in goodsinfo.colorsize.size" :key="sizeindex"
							@click="selectsizeindex=sizeindex"
							>
							{{sizeitem.name}}
							</div>
						</div>
					</div>
					<div class="wd-flex wd-row-between other" v-if="goodsinfo.seckilltype==1">
						<div class="title">拼团人数：</div>
						<div class="wd-row-grow wd-theme-666 wd-flex wd-row-left wd-flex-wrap">
							<div class="spec wd-flex wd-row-between" :class="teamnumindex==selectteamnumindex ? 'select' : ''" 
							v-for="(teamnumitem,teamnumindex) in teamnumlist" :key="teamnumindex"
							@click="selectteamnum(teamnumindex)"
							>
							{{teamnumitem.teamnum}}人
							</div>
						</div>
					</div>
					<div class="wd-flex wd-row-between other">
						<div class="title">购买数量：</div>
						<div class="wd-row-grow wd-theme-666">
							<el-input-number :min="1" :max="100" v-model="buynum" size="mini"></el-input-number>
							库存：
							<span class="wd-font-bold" :class="[goodsinfo.stocknumstate === '充足' ? 'wd-success' : 'wd-danger']">{{ goodsinfo.stocknumstate }}</span>
						</div>
					</div>
					<div class="">
						<div class="wd-m-t-20 wd-flex wd-row-between other" v-if="flag==1">
							<div class="title"></div>
							<div class="wd-row-grow">
							<el-button class="btncart btn" type="warning" @click="addorbuy('buy')">
								<i class="wd-icon">&#xe6a4;</i>
								<span class="wd-m-l-5">立即兑换</span>
							</el-button>
							</div>
						</div>
						<div class="wd-flex wd-row-left btngroup"  v-else-if="goodsinfo.seckilltype<1">
							<el-button class="btnbuy btn" type="warning" @click="addorbuy('buy')">立即购买</el-button>
							<el-button class="btncart btn" type="primary" @click="addorbuy('add')">
								<i class="wd-icon">&#xe600;</i>
								<span class="wd-m-l-5">加入购物车</span>
							</el-button>
						</div>
						<div class="wd-flex wd-row-left btngroup"  v-else-if="goodsinfo.seckilltype==3">
							<el-button class="btnbuy btn" type="warning" @click="addorbuy('yushou')">预售购买</el-button>
						</div>
						<div class="wd-flex wd-row-left btngroup"  v-else-if="goodsinfo.seckilltype==1">
							<el-button class="btnbuy_pintuan btn" type="warning" @click="addorbuy('danbuy')">
								<span>¥{{$weidajs.numberFixed(goodsinfo.price1)}}</span><br>
								<span class="wd-font-12">单独购买</span></el-button>
							<el-button class="btnbuy_pintuan btn" type="primary" @click="addorbuy('pintuan')">
								<span>¥{{$weidajs.numberFixed(selectprice)}}</span><br>
								<span class="wd-font-12">我要开团</span>
							</el-button>
						</div>
					</div>
					<div class="wantuancss" v-if="goodsinfo.seckilltype==1 && addteamlist!=''">
						<div  v-for="(ptitem,ptindex) in addteamlist" :key="ptindex">
							<div class="hintrow wd-flex wd-row-between" v-if="ptindex===0">
								<div>凑团拼购，可直接参与</div>
								<div>{{teamcount}}人已拼</div>
							</div>
							<div class="teamrow wd-flex wd-row-between wd-m-b-10">
								<div class=" a">
									<div class="wd-flex">
										<el-avatar class="wd-row-noshrink" size="large" :src="$wdpicurl(ptitem.headpic,true)"></el-avatar>
										<div class="wd-m-l-10  wd-text-line1">
											<span class="">{{ptitem.nickname}}</span>
										</div>
										<div class="wd-row-noshrink">
											的团
										</div>
									</div>
								</div>
								<div class="wd-row-noshrink b">
									<div class="wd-font-12">
									还差<span class="wd-theme">{{ptitem.needmemnum}}</span>人成团	
									</div>
									<div class="wd-flex">
										<span class="wd-m-r-5 wd-theme-999 wd-font-12">剩余</span>
										<wd-count-down separator="zh" color="#999" separator-color="#999" :timestamp="ptitem.diffsec"></wd-count-down>
										<!-- <u-count-down :show-days="false" separator="colon" font-size="24" bg-color="#fff8f0" separator-size="24" separator-color="#999" color="#999" :timestamp="ptitem.diffsec"></u-count-down> -->
									</div>
								</div>
								<div class="wd-row-noshrink c">
									<el-button type="primary" size="mini" @click="addteam(ptitem.id,ptitem.memnum)">去参团</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="shop">
					<div>
						<div class="shopname">{{ goodsinfo.branchname }}</div>
						<div class="shopinfo">
							<div class="a">商家评分：{{ goodsinfo.branchrate|numberFormatter }}分</div>
							<div class="a">商家等级：{{ goodsinfo.branchlevel }}</div>
						</div>
					</div>
					<div class="suggest">
						<div class="title wd-flex wd-row-between">
							<div>看了又看</div>
							<div class="wd-cursor" @click="getsuggest">换一换</div>
						</div>
						<div class="detail">
							<template v-for="(item, index) in sugguestlist">
								<div class="goods" :key="index" v-if="index < 2" @click="setnewgoods(item.goodsid, item.goodsname)">
									<div class="img"><el-image class="img" :src="$wdpicurl(item.pic1)"></el-image></div>
									<div class="name wd-line-2">{{ item.goodsname }}</div>
									<div class="price wd-theme wd-m-t-10">¥{{ item.retailprice }}</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="wd-flex wd-row-between goodsdetailmsg wd-col-top">
				<div class="left wd-row-noshrink">
					<div class="top">
						<div class="title">热搜推荐</div>
						<div class="detail wd-flex wd-row-left wd-flex-wrap">
							<div class="tag" v-for="(item, index) in hotwordlist" :key="index">{{ item.word }}</div>
						</div>
					</div>
					<div class="suggest">
						<div class="title">热卖推荐</div>
						<div class="detail">
							<div class="goods" v-for="(item, index) in hotlist" :key="index" @click="setnewgoods(item.goodsid, item.goodsname)">
								<div class="img"><el-image class="img" :src="$wdpicurl(item.pic1)"></el-image></div>
								<div class="name wd-line-2">{{ item.goodsname }}</div>
								<div class="price wd-theme wd-m-t-10">¥{{ item.retailprice }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="right wd-row-grow ">
					<div class="title">商品详情</div>
					<div v-html="goodsinfo.detailmsg"></div>
					<div class="title commentstart">商品评价</div>
					<div class="wd-flex wd-row-between wd-p-t-20 commentcss">
						<div class="wd-row-noshrink bl">
							<div class="">好评率：</div>
							<div class="wd-font-30 wd-theme value">{{ $weidajs.numberFixed(commentinfo.commentpercent, 0) }}%</div>
						</div>
						<div class="wd-row-grow wd-flex wd-row-left wd-flex-wrap ">
							<div class="bt" :class="commentcon == 'all' ? 'select' : ''" @click="setcon('all')"><span>全部</span></div>
							<div class="bt" :class="commentcon == 'new' ? 'select' : ''" @click="setcon('new')"><span>最新</span></div>
							<div class="bt" :class="commentcon == 'good' ? 'select' : ''" @click="setcon('good')">
								<span>质量不错({{ commentinfo.commentgoodnum }})</span>
							</div>
							<div class="bt" :class="commentcon == 'normal' ? 'select' : ''" @click="setcon('normal')">
								<span>质量一般({{ commentinfo.commentnormalnum }})</span>
							</div>
							<div class="bt" :class="commentcon == 'pic' ? 'select' : ''" @click="setcon('pic')">
								<span>有图({{ commentinfo.commentpicnum }})</span>
							</div>
						</div>
					</div>
					<div class="commentlistcss" ref="commentlistref">
						
						<div class="item wd-flex wd-row-between wd-col-top" v-for="(commentitem, commentindex) in commentlist" :key="commentindex">
							<div class="userinfo wd-row-noshrink wd-flex wd-row-left">
								<div class=""><el-avatar size="small" :src="$wdpicurl(commentitem.headpic, true)"></el-avatar></div>
								<div class="nickname">{{ commentitem.nickname }}</div>
							</div>
							<div class="wd-row-grow value ">
								<div class="wd-flex wd-row-between">
									<div>
										<el-rate :value="$weidajs.ratevalue(commentitem.rate)" disabled :colors="['#FF4C4C','#FF4C4C','#FF4C4C']"></el-rate>
									</div>
									<div class="wd-theme-999 wd-font-12">
										{{commentitem.optdate}}
									</div>
								</div>
								<div v-html="$weidajs.replaceAll(commentitem.comment, '\n', '<br>')"></div>
								<div class="wd-flex wd-row-left wd-m-t-10">
									<el-image :preview-src-list="commentpicview(commentindex,1)" v-if="commentitem.pic1!==''" :src="$wdpicurl(commentitem.pic1)" class="img"></el-image>
									<el-image :preview-src-list="commentpicview(commentindex,2)" v-if="commentitem.pic2!==''" :src="$wdpicurl(commentitem.pic2)" class="img"></el-image>
									<el-image :preview-src-list="commentpicview(commentindex,3)" v-if="commentitem.pic3!==''" :src="$wdpicurl(commentitem.pic3)" class="img"></el-image>
									<el-image :preview-src-list="commentpicview(commentindex,4)" v-if="commentitem.pic4!==''" :src="$wdpicurl(commentitem.pic4)" class="img"></el-image>
									<el-image :preview-src-list="commentpicview(commentindex,5)" v-if="commentitem.pic5!==''" :src="$wdpicurl(commentitem.pic5)" class="img"></el-image>
									<el-image :preview-src-list="commentpicview(commentindex,6)" v-if="commentitem.pic6!==''" :src="$wdpicurl(commentitem.pic6)" class="img"></el-image>
								</div>
							</div>
						</div>
						<div class="wd-fr">
							<el-pagination
								:total="commentcnt"
								:background="true"
								layout="prev, pager, next"
								:page-size="$wd_limit"
								:small="true"
								@size-change="pagesizechange"
								@current-change="currentchange"
								@prev-click="prevclick"
								@next-click="nextclick"
							></el-pagination>
						</div>
					</div>
				</div>
			</div>
			<el-dialog :visible.sync="addcartsuccuess" custom-class="addcartsuccess" title="温馨提示" width="600px">
				<div class="wd-flex wd-row-left">
					<div class="wd-m-l-20 wd-m-r-20 wd-width-30"><i class="wd-icon wd-font-28 wd-success">&#xe603;</i></div>
					<div><div class="wd-font-bold">添加成功</div></div>
				</div>
				<div class="wd-flex wd-row-left">
					<div class="wd-m-l-20 wd-m-r-20 wd-width-30"></div>
					<div>
						<div class="wd-m-t-10">
							<el-button size="mini" @click="addcartsuccuess = false">继续购物</el-button>
							<el-button size="mini" type="primary" @click="gotocart">去购物车结算</el-button>
						</div>
					</div>
				</div>
				<div class="">
					<div class="title"><span>热卖产品</span></div>
					<div class="detail">
						<div class="goods" v-for="(item, index) in hotlist4" :key="index" @click="setnewgoods(item.goodsid, item.goodsname)">
							<div class="img"><el-image class="img" :src="$wdpicurl(item.pic1)"></el-image></div>
							<div class="name wd-line-2">{{ item.goodsname }}</div>
							<div class="price wd-theme wd-m-t-10">¥{{ item.retailprice }}</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import Top from '@/components/layout/Top.vue';
import Footer from '@/components/layout/Footer.vue';
import PicZoom from 'vue-piczoom';
import { regionData } from 'element-china-area-data';
import WdCountDown from '@/components/WdCountDown/index.vue'
export default {
	name: 'Goodsinfo',
	computed: {
		...mapState(['logininfo'])
		// 	gethotlist4: function() {
		// 		return this.gethot(4);
		// 	},
		// 	gethotlist2: function() {
		// 		return this.gethot(2);
		// 	}
	},
	components: {
		Top,
		Footer,
		PicZoom,
		WdCountDown
	},
	data() {
		return {
			flag:0,//0正常 1积分兑换
			options: regionData,
			hotlist: [],
			goodsinfo: {},
			goodsid: '',
			goodspiclist: [],
			buynum: 1,
			bigpic: '',
			selectimeiindex: -1,
			selectspecindex: -1,
			selectspecindex2:-1,
			selectstocknum:"0",
			selectcolorindex:-1,
			selectsizeindex:-1,
			isbuy: false,
			addrinfo: {},
			selectprice: 0,
			selectteamnumindex:0,
			addcartsuccuess: false,
			sugguestlist: [],
			hotlist4: [],
			hotwordlist: [],
			commentcon: 'all',
			commentcnt: -1,
			commentpage: 0,
			commentpagecnt:0,
			commentlist: [],
			commentinfo: {
				commentpercent: 100,
				commentgoodnum: 0,
				commentnormalnum: 0,
				commentpicnum: 0
			},
			allseconds: 0,
			allseconds_start:0,
			showmoreclass:false,
			sechour:0,
			secminute:0,
			secsecond:0,
			seckilltimer:null,
			startcountdown_s:false,
			yingxiaolist:"",
			yingxiaoshow:false,
			buytype:'',
			addteamlist:[],
			teamcount:0,
			teamid:'',
			oldteamid:'',
			yushouList: [{
				name: '开始'
			}, {
				name: '结束'
			}, {
				name: '发货'
			}],
			yushouminutes:0,
			expressamount:0,
			colorsizedetail:"",
			teamnumlist:[],
		};
	},
	methods: {
		addteam(teamid,memnum){
			if (this.goodsinfo.colorsize.color!=''){
				if (this.selectcolorindex<0) {
					this.$wd_toast("请选择颜色","error");
					return;
				}
				if (this.selectsizeindex<0) {
					this.$wd_toast("请选择尺码","error");
					return;
				}
			}
			this.teamid=teamid;
			this.buytype="pintuan";
			for (var i = 0; i < this.teamnumlist.length; i++) {
				if (this.teamnumlist[i].teamnum==memnum){
					this.selectteamnumindex=i;
					break;
				}
			}
			if (this.goodsinfo.needcolorsize!=''){
				this.getselectinfo2();	
			}else{
				this.getselectinfo();
			}
			this.isbuy=true;
			this.save();
		},
		selectteamnum(index){
			this.teamid="";
			// if(this.$weidajs.isEmpty(this.teamid)){
				this.selectteamnumindex=index;
				if (this.goodsinfo.needcolorsize!=''){
					this.getselectinfo2();	
				}else{
					this.getselectinfo();
				}
			// }else{
			// 	this.teamid="";
			// }
		},
		commentpicview(commentindex,idx){
			var item=this.commentlist[commentindex];
			var list=[];
			if (item.pic1!=''){
				list.push(item.pic1);
			}
			if (item.pic2!=''){
				list.push(item.pic2);
			}
			if (item.pic3!=''){
				list.push(item.pic3);
			}
			if (item.pic4!=''){
				list.push(item.pic4);
			}
			if (item.pic5!=''){
				list.push(item.pic5);
			}
			if (item.pic6!=''){
				list.push(item.pic6);
			}
			if (idx<=list.length){
				var tmp=list[idx-1];
				list.splice(idx-1,1);
				list.unshift(tmp);
			}
			return list;
		},
		gopage(page) {
			if (page < 0) {
				if (this.commentpage <= 1) {
					return;
				} else {
					this.commentpage;
				}
			} else {
				if (page == this.commentpagecnt) {
					return;
				} else {
					this.commentpage++;
				}
			}
			this.commentpage;
			this.loadcomment();
		},
		pagesizechange(e) {
			this.commentpage = e - 1;
			this.loadcomment();
		},
		currentchange(e) {
			this.commentpage = e - 1;
			this.loadcomment();
		},
		prevclick(e) {
			this.commentpage = e - 1;
			this.loadcomment();
		},
		nextclick(e) {
			this.commentpage = e - 1;
			this.loadcomment();
		},
		setcon(con) {
			this.commentcon = con;
			(this.commentcnt = -1), (this.commentpage = 0);
			this.commentlist = [];
			this.loadcomment();
		},
		loadcommentnum() {
			this.$wd_request('goods_comment_num', { goodsid: this.goodsid })
				.then(data => {
					this.commentinfo = data.value;
				})
				.catch(() => {});
		},
		loadcomment() {
			if (this.commentcnt == -1) {
				this.commentpage = 1;
			} else {
				if (this.commentpage * this.$wd_limit >= this.commentcnt) {
					return;
				} else this.commentpage++;
			}
			let indata = {
				cnt: this.commentcnt,
				page: this.commentpage,
				con: this.commentcon,
				goodsid: this.goodsid
			};
			this.$wd_request('mem_comment_list', indata,true,".commentlistcss")
				.then(data => {
					console.log(data);
					if (this.commentcnt == -1) {
						this.commentcnt = data.cnt;
						this.commentlist = data.value;
						this.commentpagecnt = Math.ceil(data.cnt / this.$wd_limit);
					} else {
						this.commentlist =(data.value);
							var d=document.getElementsByClassName("commentstart");
							document.documentElement.scrollTop=d[0].offsetTop;
					}
				})
				.catch(() => {});
		},
		loadyingxiao(){
			this.$wd_request("loadyingxiao",{goodsid:this.goodsid})
			.then(data=>{
				this.yingxiaolist=data.value;
			})
			.catch(()=>{})
		},
		handleChange(value) {
			localStorage.setItem('wd_addr', value);
			this.$store.commit('setaddrinfo', value);
		},
		gotocart() {
			this.$router.push({ name: 'Cart' });
		},
		gethot(cnt) {
			var arr = this.hotlist;
			var shuffled = arr.slice(0),
				i = arr.length,
				min = i - cnt,
				temp,
				index;
			while (i-- > min) {
				index = Math.floor((i + 1) * Math.random());
				temp = shuffled[index];
				shuffled[index] = shuffled[i];
				shuffled[i] = temp;
			}
			return shuffled.slice(min);
		},
		getsuggest() {
			this.sugguestlist = this.gethot(2);
		},
		gethot4() {
			this.hotlist4 = this.gethot(4);
		},
		selectspecopt(index) {
			this.selectspecindex = index;
		},
		gethotwordlist() {
			this.$wd_request('gethotword')
				.then(data => {
					this.hotwordlist = data.value;
				})
				.catch(() => {});
		},
		save() {
			let sharecode = ''; //uni.getStorageSync(this.goodsinfo.id);
			// let tnum = parseInt(this.buynum);
			// let tstocknum = parseInt(this.selectstocknum);
			let stockid;
			let imei = '';
			let barcodeid;
			let deliverid;
			let branchid = this.logininfo.branchid;
			let sizeid="";
			let colorid="";
			let teamnum=0;
			if (this.goodsinfo.colorsize.color==''){
				stockid = this.goodsinfo.speclist[this.selectspecindex].stockid;
				imei = '';
				barcodeid = this.goodsinfo.speclist[this.selectspecindex].barcodeid;
				deliverid = this.goodsinfo.speclist[this.selectspecindex].deliverid;
			}else{
				stockid=this.goodsinfo.speclist[this.selectspecindex2].stockid;
				barcodeid=this.goodsinfo.speclist[this.selectspecindex2].barcodeid;
				deliverid=this.goodsinfo.speclist[this.selectspecindex2].deliverid;
				colorid=this.goodsinfo.colorsize.color[this.selectcolorindex].colorid;
				sizeid=this.goodsinfo.colorsize.size[this.selectsizeindex].sizeid;
				imei=colorid+"|"+sizeid;
			}
			if (this.buytype=="pintuan"){
				teamnum=this.teamnumlist[this.selectteamnumindex].teamnum;
			}
			// let pkgs = 1;
			if (this.isbuy) {
				console.log(this.isbuy);
				//购买
				let addrid = '';
				if (this.addrinfo === undefined || this.addrinfo == '' || this.addrinfo == null) {
					this.$wd_msg('请选择配送地址');
					return;
				}
				console.log('直接购买');
				//确认订单页面
				if (this.addrinfo !== null) {
					addrid = this.addrinfo.id || '';
				}
				// if (parseFloat(this.buynum)>parseFloat(this.goodsinfo.stocknum)){
				// 	this.$wd_msg('购买数量超出可购数量');
				// 	return;
				// }
				if (this.flag==1){
					//积分兑换商品
					var goodsintegral=parseFloat(this.goodsinfo.integralexchange)*parseFloat(this.buynum);
					var canuseintegral=parseFloat(this.logininfo.myinfo.canuseintegral);
					if (goodsintegral>canuseintegral){
						this.$wd_msg('当前积分['+canuseintegral+'],不能兑换此商品所需的积分['+goodsintegral+']');
						return;
					}
				}
				let param = {
					buyflag: 9,
					barcodeid: barcodeid,
					seckillid: this.seckillid,
					num: this.buynum,
					skdetailid: 0,
					sharecode: this.sharecode,
					branchid: branchid,
					stockid: stockid,
					imei: imei,
					deliverid: deliverid,
					addrid: addrid,
					flag:this.flag,
					buytype:this.buytype,
					sizeid:sizeid,
					colorid:colorid,
					teamnum:teamnum
				};
				if (this.goodsinfo.seckilltype!='' && this.buytype!="danbuy"){
					param.seckillid=this.seckillid;
				}else{
					param.seckillid=0;
				}
				if (this.buytype=="pintuan"){
					param.buyflag=9;
					param.teamid=this.teamid;
				} else{
					param.buyflag=9;
					param.teamid="";
				}
				this.$router.push({
					name: 'Buy',
					query: param
				});
				// let routeUrl = this.$router.resolve({
				//      name: "Buy",
				//      params: param
				//    });
				//    window.open(routeUrl.href, '_blank');
			} else {
				//加购物车
				let indata = {
					teammemguid: this.logininfo.teammemguid,
					barcodeid: barcodeid,
					num: this.buynum,
					retailprice: this.selectprice,
					skdetailid: this.goodsinfo.skdetailid,
					sharecode: sharecode,
					stockid: stockid,
					imei: imei,
					deliverid: deliverid,
					sizeid:sizeid,
					colorid:colorid
				};
				this.$wd_request('addcart', indata, true)
					.then(() => {
						this.addcartsuccuess = true;
						// this.$wd_toast(data.msg);
						// this.toclose();
						// var txt=parseInt(this.cartnum)+this.buynum;
						// this.cartnum=txt.toString();
						// this.$store.commit("setcartnum",this.cartnum);
					})
					.catch(() => {});
			}
		},
		getselectinfo(){
			this.selectstocknum=0;
			this.selectprice=0;
			if (this.goodsinfo.needimei!=0){
				this.selectimeiindex=0;
			}
			if (this.goodsinfo.seckilltype=='1'){
				this.selectprice=this.teamnumlist[this.selectteamnumindex].appprice;
				
			}else{
				this.selectprice=this.goodsinfo.speclist[this.selectspecindex2].price1;
			}
			// if (this.buytype=='pintuan'){
			// 	this.selectprice=this.teamnumlist[this.selectteamnumindex].appprice;
			// }
			// if ((this.selectimeiindex>-1) && (this.selectspecindex>-1)){
			// 	this.selectstocknum=this.goodsinfo.speclist[this.selectspecindex].num;
			// 	if (this.buytype=='danbuy'){
			// 		this.selectprice=this.goodsinfo.speclist[this.selectspecindex].price1;
			// 	}else if (this.buytype=='pintuan'){
			// 		this.selectprice=this.teamnumlist[this.selectteamnumindex].appprice;
			// 	}else{
			// 		this.selectprice=this.goodsinfo.speclist[this.selectspecindex].appprice;
			// 	}
			// }
			// }
			
		},
		getselectinfo2(){//颜色尺码 的
			this.selectstocknum=0;
			this.selectprice=0;

			if (this.goodsinfo.seckilltype=='1'){
				this.selectprice=this.teamnumlist[this.selectteamnumindex].appprice;
				
			}else{
				this.selectprice=this.goodsinfo.speclist[this.selectspecindex2].price1;
			}
			// if ((this.selectcolorindex>-1) && (this.selectsizeindex>-1) && (this.selectspecindex2>-1)){
			// 	var imei=this.goodsinfo.colorsize.color[this.selectcolorindex].colorid+"|"+this.goodsinfo.colorsize.size[this.selectsizeindex].sizeid;
			// 	var pkgs=this.goodsinfo.colorsize.salepkgs[this.selectspecindex2];
			// 	this.selectstocknum=this.goodsinfo.speclist[this.selectspecindex2].num;
			// 	if (this.buytype=='danbuy'){
			// 		this.selectprice=this.goodsinfo.speclist[this.selectspecindex2].price1;
			// 	}else if (this.buytype=='pintuan'){
			// 		this.selectprice=this.teamnumlist[this.selectteamnumindex].appprice;
			// 	}else{
			// 		this.selectprice=this.goodsinfo.speclist[this.selectspecindex2].appprice;
			// 	}
			// }
		},
		loadaddteamlist(){
			let indata={
				seckillid:this.seckillid,
				goodsid:this.goodsid,
				teamid:this.teamid
			}
			this.$wd_request("getaddteamlist", indata)
			.then(data=>{
				this.addteamlist=data.value;
				this.teamcount=data.count;
				if (!this.$weidajs.isEmpty(this.teamid)){
					let teamnum=data.value[0]["teamnum"];
					for (var i = 0; i < this.teamnumlist.length; i++) {
						if (this.teamnumlist[i].teamnum==teamnum){
							this.selectteamnumindex=i;
							break;
						}
					}
				}else{
					this.selectteamnumindex=0;
				}
				this.getselectinfo2();
			})
			.catch(()=>{});
		},
		addorbuy(type) {
			this.buytype=type;
			if (type=="add"){
				this.isbuy=false;
			}else if (type=="buy" ||type=="danbuy" ||type=="pintuan" || type=="yushou"){
				this.teamid="";//this.oldteamid;
				this.isbuy=true;
			}
			if (this.goodsinfo.colorsize.color!=''){
				if (this.selectcolorindex<0) {
					this.$wd_toast("请选择颜色","error");
					return;
				}
				if (this.selectsizeindex<0) {
					this.$wd_toast("请选择尺码","error");
					return;
				}
			}
			this.save();
			// if (this.selectimeiindex<0 && this.goodsinfo.needimei==0){
			// 	this.$wd_toast("请选择生产日期");
			// 	return;
			// }
			// if (this.selectspecindex<0){
			// 	this.$wd_toast("请选择规格");
			// 	return;
			// }
			// let tnum=parseInt(this.buynum);
			// let tstocknum=parseInt(this.selectstocknum);
			// if (tnum>tstocknum){
			// 	this.$wd_dialog("温馨提示","您所选的门店该商品可能暂缺货，需要从仓库调货，请等待3天左右或者切换其他门店购买！点击【确定】继续购买",true,this,
			// 	function(that,data){
			// 		that.save();
			// 	},function(that,data){

			// 	})
			// }else{
			// 	this.save();
			// }
		},
		selectgoodspic(index) {
			for (var i = 0; i < this.goodspiclist.length; i++) {
				if (i !== index) {
					this.goodspiclist[i].select = false;
				} else {
					this.goodspiclist[i].select = true;
					this.bigpic = this.goodspiclist[i].picurl;
				}
			}
		},
		addtocart() {},
		setnewgoods(goodsid, goodsname) {
			if (goodsid === this.goodsid) {
				return;
			}
			this.goodsid = goodsid;
			document.title = goodsname;
			this.loadgoods();
		},
		loadgoods() {
			this.goodsinfo = {};
			this.goodspiclist = [];
			this.selectspecindex = -1;
			this.$wd_request('goodsinfo', { goodsid: this.goodsid,seckillid:this.seckillid }, true,".goodsinfo").then(data2 => {
				// this.goodsinfo=data;
				var data = data2.value;
				document.title = data.goodsname;
				this.seckillid=data.skdetailid;
				this.allseconds=data.intdiff;
				this.start_calcseckill();

				if (data.seckilltype==1){//拼团
					if (parseInt(data.seckilldata.teamnum1)>0){
						this.teamnumlist.push({
							teamnum:data.seckilldata.teamnum1,
							appprice:data.seckilldata.appprice
						})
					}
					if (parseInt(data.seckilldata.teamnum2)>0){
						this.teamnumlist.push({
							teamnum:data.seckilldata.teamnum2,
							appprice:data.seckilldata.appprice2
						})
					}
					if (parseInt(data.seckilldata.teamnum3)>0){
						this.teamnumlist.push({
							teamnum:data.seckilldata.teamnum3,
							appprice:data.seckilldata.appprice3
						})
					}
					this.loadaddteamlist()
				}else if (data.seckilltype==3){//预售
					let ds=data.seckilldata.activedatestart;
					let de=data.seckilldata.activedateend;
					let se=data.seckilldata.sendstartdate;
					this.yushouminutes=this.$weidajs.datediffmi(ds+' '+data.seckilldata.activetimestart,
					de+' '+data.seckilldata.activetimeend)*60;
					this.yushouList[0].name=ds.substr(5,2)+"/"+ds.substr(8,2)+ "开始";
					this.yushouList[1].name=de.substr(5,2)+"/"+de.substr(8,2)+ "结束";
					this.yushouList[2].name="预计"+se.substr(5,2)+"/"+se.substr(8,2)+"发货";
				}else{
					this.teamid="";
					this.oldteamid="";
				}

				//判断能否积分兑换
				if (data.canintegralexchange!=="0"){
					if (this.flag==1){
						this.flag=0;
					}
				}
				if (data.pic1 != '') {
					this.goodspiclist.push({ picurl: data.pic1, select: true });
					this.bigpic = data.pic1;
				}
				if (data.pic2 != '') {
					this.goodspiclist.push({ picurl: data.pic2, select: false });
				}
				if (data.pic3 != '') {
					this.goodspiclist.push({ picurl: data.pic3, select: false });
				}
				if (data.pic4 != '') {
					this.goodspiclist.push({ picurl: data.pic4, select: false });
				}
				if (data.pic5 != '') {
					this.goodspiclist.push({ picurl: data.pic5, select: false });
				}
				var imgUrl = data.detailmsg;
				imgUrl = this.$weidajs.replaceAll(imgUrl, '../../../uploads/', this.$wd_hosturl + '/uploads/');
				// imgUrl=imgUrl.replace(new RegExp("https:///uploads/","gm"),"https://app.peisong-ge.com/uploads/");
				// imgUrl=imgUrl.replace(new RegExp("../../../uploads/","gm"),"https://app.peisong-ge.com/uploads/");
				imgUrl=imgUrl.replace(new RegExp("../../uploads/","gm"),"https://app.peisong-ge.com/uploads/");
				// imgUrl=imgUrl.replace(new RegExp("../uploads/","gm"),"https://app.peisong-ge.com/uploads/");
				// imgUrl=imgUrl.replace(/\\/,"/");
				data.detailmsg = imgUrl;
				this.loadyingxiao();
				this.goodsinfo = data;
				if (!this.goodsinfo.needcolorsize){
					this.selectspecindex = 0;
				}else{
					this.selectspecindex2=0;
				}
				window.scrollTo(0, 0);
			});
		},
		loadhot() {
			this.$wd_request('goodslist', { contype: 1 }).then(data => {
				this.hotlist = data.value;
				this.getsuggest();
				this.gethot4();
			});
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname,
					flag:this.flag
				}
			});
		},
		start_calcseckill(){
			this.clear_calcseckill();
			this.seckilltimer = setInterval(() => {
				this.allseconds--;
				if (this.allseconds < 0) {
					return this.clear_calcseckill();
				}
				this.diffTime(this.allseconds);
				
			}, 1000);
		},
		clear_calcseckill(){
			clearInterval(this.seckilltimer);
			this.seckilltimer = null;
		},
		diffTime(min) {
			var diff=min*1000;//endDate.getTime() - startDate.getTime();//时间差的毫秒数  
			//计算出相差天数  
			// var days=Math.floor(diff/(24*3600*1000));  
			//计算出小时数  
			var leave1=diff%(24*3600*1000);    //计算天数后剩余的毫秒数  
			var hours=Math.floor(leave1/(3600*1000));  
			//计算相差分钟数  
			var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
			var minutes=Math.floor(leave2/(60*1000));  
			//计算相差秒数  
			var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
			var seconds=Math.round(leave3/1000);  
			
			hours = hours < 10 ? '0' + hours : hours;
			minutes = minutes < 10 ? '0' + minutes : minutes;
			seconds = seconds < 10 ? '0' + seconds : seconds;
			
			this.sechour=hours;
			this.secminute=minutes;
			this.secsecond=seconds;
			this.startcountdown=true;
		}, 
		selectspec_2(index){
			this.selectspecindex2=index;
			this.getselectinfo2();
		},
		selectcolor(index){
			this.selectcolorindex=index;
			this.getselectinfo2();
		},
		selectsize(index){
			this.selectsizeindex=index;
			this.getselectinfo2();
		},
	},
	activated() {
		// console.log(this.$route.query);
		// console.log(this.$route.params);
		// var goodsid = this.$route.params.goodsid || '1';
		// var goodsname = this.$route.params.goodsname || '';
		var goodsid = this.$route.query.goodsid || '0';
		var goodsname = this.$route.query.goodsname || '';
		var flag=this.$route.query.flag||0;
		this.seckillid=this.$route.query.seckillid||"";
		this.teamid=this.$route.query.teamid||"";
		this.oldteamid=this.teamid;
		flag=parseInt(flag);
		if (flag!=0 && flag!=1){
			flag=0;
		}
		if (this.$weidajs.isEmpty(goodsname)) {
			goodsname = '加载中...';
		}
		document.title = goodsname;
		if (goodsid !== this.goodsid || flag!=this.flag) {
			this.goodsid = goodsid;
			this.flag=flag;
			this.loadgoods();
			this.loadcomment();
			this.loadcommentnum();
		}
	},
	deactivated() {
		this.addcartsuccuess = false;
	},
	created() {
		this.loadhot();
		this.gethotwordlist();
	}
};
</script>
<style lang="scss">
.addcartsuccess {
	border: 6px solid rgba(0, 0, 0, 0.3) !important;
	border-radius: 5px !important;
	box-shadow: none;
}
// .selectaddrcss {
// 	.el-input__inner {
// 		background: transparent;
// 		border: none;
// 		// width: 200px;
// 	}
// }
</style>
<style lang="scss" scoped>
::v-deep .mouse-cover-canvas {
	left: 580px !important;
	top: 50px !important;
}
.countdown{
		height: 44px;
		line-height: 44px;
		color: #FFFFFF;
		background: linear-gradient(to top, #ff4c4c 0%, #ff6666 100%);
		display: flex;
		justify-content: space-between;
		flex-shrink: 0;
		margin-bottom: 10px;
		width: 100%;
		.title{
			text-align: center;
			font-size: 20px;
			font-weight: 700;
			width: 100px;
		}
		.value{
			width: 100px;
			text-align: center;
		}
		.timer{
			font-size: 14px;
			text-align: center;
			width: 130px;
			height: 30px;
			display: block;
			margin-top:3px;
			.a{
				position: relative;
				float: left;
				width: 30px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				background-color: #2f3430;
				margin-right: 20px;
				color: white;
				font-size: 16px;
				&::after{
					content: ":";
					display: block;
					position: absolute;
					right: -20px;
					font-weight: bolder;
					font-size: 18px;
					width: 20px;
					height: 100%;
					top: 0;
				}
				&.b{
					margin-right: 0;
					&::after{
						content: "";
					}
				}
			}
		}
	}
.addcartsuccess {
	.title {
		margin: 10px 0;
	}
	.detail {
		display: flex;
		justify-content: flex-start;
		overflow-x: hidden;
		.goods {
			width: 25%;
			flex-shrink: 0;
			cursor: pointer;
			.img {
				width: 100px;
				height: 100px;
				&:hover {
					border: 1px solid $wd-theme;
				}
			}
			.name {
				margin-top: 10px;
				&:hover {
					color: $wd-theme;
				}
			}
			.price {
				font-weight: bold;
			}
		}
	}
}
.nav {
	margin: 10px 0;
}
.goodsdetailmsg {
	margin-top: 20px;
	.left {
		width: 236px;
		box-sizing: border-box;

		.top {
			border: 1px solid #ececec;
			.title {
				background: #f6f6f6;
				height: 38px;
				line-height: 38px;
				font-size: 14px;
				padding: 0 14px;
			}
			.detail {
				.tag {
					margin: 10px;
					&:hover {
						cursor: pointer;
						color: $wd-theme;
					}
				}
			}
		}
		.suggest {
			border: 1px solid #ececec;
			.title {
				background: #f6f6f6;
				height: 38px;
				line-height: 38px;
				font-size: 14px;
				padding: 0 14px;
			}
			.detail {
				padding: 0 5px;
				.goods {
					margin: 0 10px 20px;
					.img {
						width: 180px;
						height: 180px;
						margin: 0 auto;
					}
					.name {
						margin: 10px 0;
					}
					.price {
						font-size: 16px;
						font-weight: 600;
					}
					&:hover {
						cursor: pointer;
					}
					// &:hover{
					// 	box-shadow:0px -1px 2px rgba(0, 0, 0, 0.3),
					// 	-1px 0px 2px rgba(0, 0, 0, 0.3),1px 0px 2px rgba(0, 0, 0, 0.3)
					// 	,0px 1px 2px rgba(0, 0, 0, 0.3);
					// }
				}
			}
		}
	}
	.right {
		margin-left: 40px;
		border: 1px solid #ececec;
		.title {
			background: #f6f6f6;
			height: 38px;
			line-height: 38px;
			font-size: 14px;
			padding: 0 14px;
		}
	}
}
.goodsinfo {
	.goodsimg {
		margin-top: 10px;
		position: relative;
		width: 398px;
		height: 490px;
		border: 1px solid #ececec;
		background-color: #fff;
		.img_lg {
			width: 396px;
			height: 396px;
			border-bottom: 1px solid #ececec;
			.img {
				width: 396px;
				height: 396px;
			}
		}
		.img_xs {
			width: 70px;
			height: 70px;
			border-bottom: 1px solid #ececec;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 5px;
			&:hover {
				cursor: pointer;
				border: 1px solid $wd-theme;
			}
			.img {
				width: 60px;
				height: 60px;
			}
			&.select {
				border: 1px solid $wd-theme;
				i {
					top: -9px;
					left: 35px;
					position: absolute;
					width: 0;
					height: 0;
					overflow: hidden;
					line-height: 0;
					font-size: 1px;
					border-width: 4px;
					border-color: #fff #fff #f22e00 #fff;
					border-style: solid;
				}
			}
		}
	}
	.info {
		border-top: 1px solid #ececec;
		.name {
			font-size: 16px;
			color: #555555;
			margin: 10px 0;
			font-weight: bold;
		}
		.sx {
			border-right: 1px solid #ececec;
			width: 1px;
			height: 42px;
			margin-left: 10px;
		}
		.price {
			.a1 {
				line-height: 32px;
				width: 90px;
				letter-spacing: 4px;
				color: #666;
				font-size: 14px;
			}
		}
		.spec {
			padding: 0 10px;
			margin: 10px 0;
			border: 1px solid $wd-border;
			margin-right: 10px;
			&.select,
			&:hover {
				cursor: pointer;
				border: 1px solid $wd-theme;
			}
		}
		.other {
			line-height: 32px;
			.title {
				width: 90px;
				// letter-spacing: 4px;
				color: #666;
				font-size: 14px;
				flex-shrink: 0;
			}
		}
		.btngroup {
			margin-top: 20px;
			.btn {
				height: 40px;
				&.btnbuy {
				}
				&.btncart {
				}
			}
		}
	}
	.shop {
		width: 200px;
		border: 1px solid #ececec;
		.shopname {
			background: linear-gradient(to top, rgba(255, 76, 76, 1) 0%, rgba(255, 102, 102, 1) 100%);
			height: 44px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			padding: 0 15px;
			color: #ffffff;
		}
		.shopinfo {
			padding: 10px 15px;
			.a {
				height: 30px;
				line-height: 30px;
			}
		}
		.suggest {
			border: 1px solid #ececec;
			.title {
				background: #f6f6f6;
				height: 38px;
				line-height: 38px;
				font-size: 14px;
				padding: 0 14px;
			}
			.detail {
				padding: 0 5px;
				.goods {
					margin: 0 10px 20px;
					.img {
						width: 160px;
						height: 160px;
						margin: 0 auto;
					}
					.name {
						margin: 10px 0;
					}
					.price {
						font-size: 16px;
						font-weight: 600;
					}
					&:hover {
						cursor: pointer;
					}
					// &:hover{
					// 	box-shadow:0px -1px 2px rgba(0, 0, 0, 0.3),
					// 	-1px 0px 2px rgba(0, 0, 0, 0.3),1px 0px 2px rgba(0, 0, 0, 0.3)
					// 	,0px 1px 2px rgba(0, 0, 0, 0.3);
					// }
				}
			}
		}
	}
}
.commentcss {
	padding: 14px 14px;
	.bl {
		width: 100px;
		margin: auto;
		text-align: center;
		margin-right: 50px;
		.value {
			padding-top: 20px;
		}
	}
	.bt {
		padding: 0 10px;
		margin: 0 10px 10px 0;
		line-height: 20px;
		color: #999999;
		border: 1px solid #e0e0e0;
		border-radius: 2px;
		cursor: pointer;
		&.select {
			color: $wd-theme;
			border-color: $wd-theme;
		}
	}
	}
	.commentlistcss{
		.item {
			padding: 15px;
			border-bottom: 1px solid #ddd;
			&:first-child{
				border-top: 1px solid #ddd;	
			}
			.userinfo {
				width: 140px;
				.nickname {
					margin-left: 10px;
					color: #666;
					font-size: 12px;
				}
			}
			.value {
				margin-left: 20px;
				color: #333;
				line-height: 1.8;
			}
		}
		.img{
			width: 50px;
			height: 50px;
			margin-right: 6px;
			border: 1px solid $wd-border;
			cursor: pointer;
			&.select{
				border: 2px solid $wd-theme;
			}
		}
	}
	.btnbuy_pintuan{
		padding:0 20px;
	}
	.wantuancss{
		background-color: #fff8f0;
		padding: 10px 10px 5px 10px;
		margin-top: 20px;
		.hintrow{
			color: #ff911b;
			height:30px;
			line-height: 30px;
			margin-bottom: 10px;
		}
		.teamrow{
			.a{
				width: 33.33%
			}
			.b{
				margin: 0 20px;
				width: 33.33%
			}
			.c{
				width: 80px;
			}
		}
	}
</style>
